import { useContext } from 'react'
import Button from '@talkdesk/cobalt-react-button'
import Link from '@talkdesk/cobalt-react-link'
import Input from '@talkdesk/cobalt-react-input'
import Label from '@talkdesk/cobalt-react-label'
import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'
import Captcha from '../Captcha'
import { LoginContext } from '../../contexts/Login'
import useLogin from '../../hooks/useLogin'
import {
  EMAIL,
  EMAIL_PLACEHOLDER,
  PASSWORD,
  PASSWORD_PLACEHOLDER,
  FORGOT_PASSWORD,
  LOGIN_ACTION
} from '../../constants/ui.labels'
import { RECOVER_PASSWORD } from '../../constants/links'

export const Login = ({
  ctx,
  siteKey,
  redirect,
  handleErrorChange,
  setIdentityProvidersDisabled,
  email,
  showCaptcha,
  csrf
}) => {
  const {
    username,
    password,
    showCaptcha: captchaVisible,
    disableForm,
    loginButtonState,
    isLoginButtonDisabled,
    recaptchaInstanceRef,
    handleUsernameChange,
    handlePasswordChange,
    handleCaptchaResponse,
    handleSubmit
  } = useLogin({
    ctx,
    email,
    showCaptcha,
    siteKey,
    csrf,
    redirect,
    handleErrorChange,
    setIdentityProvidersDisabled
  })

  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        handleSubmit()
      }}
    >
      <Box paddingBottom={4}>
        <Label htmlFor="login-email">{EMAIL}</Label>
        <Input
          id="login-email"
          value={username}
          tabIndex={'0'}
          autoFocus
          onChange={handleUsernameChange}
          type="email"
          placeholder={EMAIL_PLACEHOLDER}
          disabled={disableForm}
        />
      </Box>
      <Box paddingBottom={4}>
        <Flex alignX="space-between" alignY="center">
          <Label htmlFor="login-password">{PASSWORD}</Label>
          <Link tabIndex={'1'} href={RECOVER_PASSWORD}>
            {FORGOT_PASSWORD}
          </Link>
        </Flex>
        <Input
          id="login-password"
          tabIndex={'0'}
          value={password}
          onChange={handlePasswordChange}
          type="password"
          placeholder={PASSWORD_PLACEHOLDER}
          disabled={disableForm}
        />
      </Box>
      {captchaVisible && siteKey !== '' && (
        <div>
          <Captcha
            siteKey={siteKey}
            recaptchaCallback={handleCaptchaResponse}
            recaptchaInstance={e => {
              recaptchaInstanceRef.current = e
            }}
          />
        </div>
      )}
      <Box paddingTop={4}>
        <Button
          tabIndex={'0'}
          htmlType="submit"
          state={loginButtonState}
          type="primary"
          shape="full-width"
          disabled={isLoginButtonDisabled}
        >
          {LOGIN_ACTION}
        </Button>
      </Box>
    </form>
  )
}

const LoginWithContext = props => {
  const ctx = useContext(LoginContext)
  return <Login ctx={ctx} {...props} />
}
LoginWithContext.displayName = 'Login'

export default LoginWithContext
